import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _castArray from 'lodash/castArray';
import _noop from 'lodash/noop';
import _head from 'lodash/head';

// Constants
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { FILTER_GROUP_CHANGE, getActions, SAVE_AS_NEW_FILTER_GROUP, FILTER_GROUP_UPDATE } from './filterHeaderView.actionTypes';
import { DEFAULT_FILTER_GROUP } from '../../../../../constants/filterSection.filterGroups';

// Components
import ActionsList from '../../../../../../../molecules/actionsList';
import { Select } from '../../../../../../../molecules/advancedSelect';
import TextualAction from '../../../../../atoms/textualAction';

// Helpers
import { getSingleValueStyles, getInputStylesInRem } from '../../../../../../../molecules/advancedSelect/styles/AdvancedSelect.styles';

// Readers
import filterGroupReader from '../../../../../readers/FilterGroup';

// Styles
import s from './filterHeaderView.module.scss';
var VISIBLE_ACTION_COUNT = 0;
var STYLE_OVERRIDES = {
  input: getInputStylesInRem,
  singleValue: getSingleValueStyles
};
var FilterHeaderView = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilterHeaderView, _PureComponent);
  var _super = _createSuper(FilterHeaderView);
  function FilterHeaderView() {
    var _this;
    _classCallCheck(this, FilterHeaderView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getSelectValue", defaultMemoize(_castArray));
    _defineProperty(_assertThisInitialized(_this), "getActions", defaultMemoize(getActions));
    _defineProperty(_assertThisInitialized(_this), "handleFilterGroupChange", function (_ref) {
      var value = _ref.value;
      var onAction = _this.props.onAction;
      onAction({
        type: FILTER_GROUP_CHANGE,
        payload: {
          selectedFilterGroup: _head(value)
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSaveFilterGroup", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: FILTER_GROUP_UPDATE
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSaveNewFilterGroup", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: SAVE_AS_NEW_FILTER_GROUP
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleActionClick", function (actionId) {
      var onAction = _this.props.onAction;
      onAction({
        type: actionId
      });
    });
    return _this;
  }
  _createClass(FilterHeaderView, [{
    key: "renderGeneralActions",
    value: function renderGeneralActions() {
      var _this$props = this.props,
        isModified = _this$props.isModified,
        saveButtonCustomClass = _this$props.saveButtonCustomClass,
        nonRenamable = _this$props.nonRenamable,
        nonDeletable = _this$props.nonDeletable;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextualAction, {
        className: "".concat(s.saveBtn__general, " ").concat(saveButtonCustomClass),
        isDisabled: !isModified,
        label: __('Save'),
        onClick: this.handleSaveFilterGroup
      }), /*#__PURE__*/React.createElement(ActionsList, {
        actions: this.getActions(isModified, nonRenamable, nonDeletable),
        onActionClick: this.handleActionClick,
        visibleActionCount: VISIBLE_ACTION_COUNT
      }));
    }
  }, {
    key: "renderActionsForDefault",
    value: function renderActionsForDefault() {
      var _this$props2 = this.props,
        isModified = _this$props2.isModified,
        shouldHideSaveFilterGroup = _this$props2.shouldHideSaveFilterGroup,
        saveButtonCustomClass = _this$props2.saveButtonCustomClass;
      if (shouldHideSaveFilterGroup) {
        return null;
      }
      return /*#__PURE__*/React.createElement(TextualAction, {
        label: __('Save Filter Group'),
        className: "".concat(s.saveBtn__default, " ").concat(saveButtonCustomClass),
        isDisabled: !isModified,
        onClick: this.handleSaveNewFilterGroup
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this$props3 = this.props,
        selectedFilterGroup = _this$props3.selectedFilterGroup,
        isReadOnly = _this$props3.isReadOnly;
      if (isReadOnly) return null;
      if (selectedFilterGroup === DEFAULT_FILTER_GROUP) {
        return this.renderActionsForDefault();
      }
      return this.renderGeneralActions();
    }
  }, {
    key: "renderFilterGroups",
    value: function renderFilterGroups() {
      var _this$props4 = this.props,
        selectedFilterGroup = _this$props4.selectedFilterGroup,
        filterGroups = _this$props4.filterGroups,
        customFilterGroupClass = _this$props4.customFilterGroupClass,
        selectComponentProps = _this$props4.selectComponentProps;
      var selectedValues = this.getSelectValue(selectedFilterGroup);
      return /*#__PURE__*/React.createElement(Select, _extends({
        className: "".concat(s.fieldGroup, " ").concat(customFilterGroupClass),
        getOptionLabel: filterGroupReader.name,
        getOptionValue: filterGroupReader.id,
        onChange: this.handleFilterGroupChange,
        options: filterGroups,
        value: selectedValues,
        styleOverrides: STYLE_OVERRIDES
      }, selectComponentProps));
    }
  }, {
    key: "renderEdited",
    value: function renderEdited() {
      var _this$props5 = this.props,
        isModified = _this$props5.isModified,
        showEditedText = _this$props5.showEditedText,
        isReadOnly = _this$props5.isReadOnly;
      if (isReadOnly || !showEditedText) return null;
      var text = isModified ? __('*Edited') : '';
      return /*#__PURE__*/React.createElement("div", {
        className: s.status
      }, text);
    }
  }, {
    key: "render",
    value: function render() {
      var filterHeaderViewContainer = this.props.filterHeaderViewContainer;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(s.container, " ").concat(filterHeaderViewContainer)
      }, this.renderFilterGroups(), this.renderActions()), this.renderEdited());
    }
  }]);
  return FilterHeaderView;
}(PureComponent);
FilterHeaderView.propTypes = {
  filterGroups: PropTypes.array.isRequired,
  selectedFilterGroup: PropTypes.string,
  onAction: PropTypes.func,
  isModified: PropTypes.bool,
  shouldHideSaveFilterGroup: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  customFilterGroupClass: PropTypes.string,
  filterHeaderViewContainer: PropTypes.string,
  saveButtonCustomClass: PropTypes.string,
  selectComponentProps: PropTypes.object,
  showEditedText: PropTypes.bool,
  nonRenamable: PropTypes.bool,
  nonDeletable: PropTypes.bool
};
FilterHeaderView.defaultProps = {
  selectedFilterGroup: DEFAULT_FILTER_GROUP,
  onAction: _noop,
  isModified: false,
  shouldHideSaveFilterGroup: false,
  customFilterGroupClass: EMPTY_STRING,
  filterHeaderViewContainer: EMPTY_STRING,
  saveButtonCustomClass: EMPTY_STRING,
  isReadOnly: false,
  selectComponentProps: EMPTY_OBJECT,
  showEditedText: false,
  nonRenamable: false,
  nonDeletable: false
};
export default FilterHeaderView;